import { LOG_TYPE } from './estimate-types'

/**
 * Per-LOG_TYPE PatientHistory `messageData` shapes — single source of truth shared by the
 * API recorder and the console renderer, so drift between them is a type error. Pre-contract
 * rows may be missing these fields; the renderer keeps fallbacks for those, new writes don't.
 */

export interface BalancePaymentAppliedHistoryData {
  amount: number
  source: string
  fromPaymentStatus: string
  toPaymentStatus: string
}

export interface BalanceRefundAppliedHistoryData {
  amount: number
  source: string
  fromPaymentStatus: string
  toPaymentStatus: string
}

export interface BalanceFinalizedHistoryData {
  fromWorkflowStatus: string
  toWorkflowStatus: string
  refinalize?: boolean
}

export interface BalanceCreatedHistoryData {
  toWorkflowStatus: string
  toPaymentStatus: string
}

export interface BalanceWorkflowTransitionHistoryData {
  fromWorkflowStatus: string
  toWorkflowStatus: string
}

export interface BalanceRecalculatedHistoryData {
  fromPaymentStatus: string
  toPaymentStatus: string
}

export interface BalancePaymentPlanCreatedHistoryData {
  months: number
  monthlyAmount: number
  firstPayment: number
  stripeSubscriptionScheduleId: string
}

export interface BalancePaymentPlanCanceledHistoryData {
  stripeSubscriptionScheduleId: string
}

export type BalanceHistoryMessageData =
  | BalancePaymentAppliedHistoryData
  | BalanceRefundAppliedHistoryData
  | BalanceFinalizedHistoryData
  | BalanceCreatedHistoryData
  | BalanceWorkflowTransitionHistoryData
  | BalanceRecalculatedHistoryData
  | BalancePaymentPlanCreatedHistoryData
  | BalancePaymentPlanCanceledHistoryData

/**
 * Keys the console renderer requires for each balance LOG_TYPE. The recorder spec asserts
 * every persisted payload carries these non-empty — a new event added without populating
 * its historyMessageData builder fails CI instead of silently rendering `$0.00 / Unknown`.
 */
export const REQUIRED_BALANCE_HISTORY_KEYS: Partial<Record<LOG_TYPE, readonly string[]>> = {
  [LOG_TYPE.ESTIMATE_BALANCE_PAYMENT_APPLIED]: ['amount', 'source'],
  [LOG_TYPE.ESTIMATE_BALANCE_REFUND_APPLIED]: ['amount', 'source'],
  [LOG_TYPE.ESTIMATE_BALANCE_PAYMENT_PLAN_CREATED]: ['months', 'monthlyAmount', 'firstPayment', 'stripeSubscriptionScheduleId'],
  [LOG_TYPE.ESTIMATE_BALANCE_PAYMENT_PLAN_CANCELED]: ['stripeSubscriptionScheduleId'],
}
